import { DefaultButton, DialogFooter, Icon, IconButton, IStackTokens, Label, MessageBar, MessageBarType, Modal, PrimaryButton, Spinner, SpinnerSize, Stack, Text, TextField, Toggle, TooltipHost } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/Hooks";
import * as Yup from 'yup';
import { InputField } from "../controls/Controls";
import { inputs } from "../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../app/Api";
import { Message } from "../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../FormProps";
import { Int32Value } from "google-protobuf/google/protobuf/wrappers_pb";
import { UpdatePasswordResponse, UpdateProfilePasswordRequest } from "../../../repository/UserManagement/Managers/profile_pb";
import { AuthenticateReply } from "../../../repository/UserManagement/authentication_pb";
import { dismissMessage, reset, update, updateThirdParty } from "./BusinessesFormSlice";
import { SessionExpiredDialog } from "../../common/SessionExpiredDialog/SessionExpiredDialog";
import { UpdateThirdPartyConnectionReplay, UpdateThirdPartyConnectionRequest, UpdateThirdPartyConnectionResponse } from "../../../repository/UserManagement/Dimensions/business_pb";


let req: UpdateThirdPartyConnectionRequest;
let promise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;



export const BusinessThirdPartyForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();


    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any } = useAppSelector((state) => {

        return { isLoading: state.businessesForm.isLoading, message: state.businessesForm.message, stage1: state.businessesForm.stage1 }
    })

    useEffect(() => {
        req = new UpdateThirdPartyConnectionRequest();

        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])

    return (
        <>

            <Formik


                initialValues={{

                    thirdPartyId: props.renderObject?.connectionId ?? '',


                }}

                validationSchema={Yup.object({

                    thirdPartyId: inputs.thirdPartyId,


                })}

                onSubmit={(values, actions) => {


                    req.setId(props.renderObject?.id);
                    req.setThirdpartyid(Number(values.thirdPartyId));
                    promise = dispatch(updateThirdParty({ body: req, headers: getHeaders() }))
                    promise.unwrap()
                        .then((res: UpdateThirdPartyConnectionResponse.AsObject) => {
                            if (res) {
                                if (props?.onSuccess) {
                                    props?.onSuccess({
                                        id: props.renderObject?.id,
                                        connectionId: values.thirdPartyId,
                                        connectionMetaData: res.success?.metadata?.value,

                                    });
                                }
                            }
                            actions.setSubmitting(false)

                        })
                        .catch((error: ApiMessage) => {
                            actions.setSubmitting(false)
                        })
                }}

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }

                            <Label  disabled={state.isLoading}>{
                                <div>
                                    {t("thirdPartyId") + ' '}
                                    <TooltipHost content={t("thirdPartyIdDesc")}>
                                        <Icon iconName="Info" aria-label={t("thirdPartyId")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <Field name="thirdPartyId"  placeholder={t("thirdPartyId")} component={InputField} disabled={state.isLoading}
                                maxLength={12}  autoFocus />


                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>


                    </Form>
                )}
            </Formik>
        </>
    );

}

